import { request } from "./authApi";

// Public: no token needed, matches the backend's Section A /publications
// routes.
export function getPublications() {
  return request("/publications");
}

export function getPublication(slug) {
  return request(`/publications/${slug}`);
}

export function getTopic(topicId) {
  return request(`/topics/${topicId}`);
}

// Admin only (Section C on the backend) — token must belong to an admin.
// Publication mutations are keyed by slug (immutable once created), not
// numeric id — matches the public detail page's own /publications/:slug
// route so admin pages can reuse the same getPublication(slug) fetch.
export function createPublication(token, data) {
  return request("/publications", { method: "POST", body: data, token });
}

export function updatePublication(token, slug, data) {
  return request(`/publications/${slug}`, { method: "PUT", body: data, token });
}

export function deletePublication(token, slug) {
  return request(`/publications/${slug}`, { method: "DELETE", token });
}

// data is a FormData (not a plain object): "category",
// "title_fa"/"title_en", "description_fa"/"description_en",
// "body_fa"/"body_en", repeated "footnotes_fa"/"footnotes_en", and may
// contain an optional "image" file and/or "remove_image" — sent as
// multipart, not JSON, since it may carry a binary upload (see
// TopicFormPage.js).
export function createTopic(token, publicationSlug, data) {
  return request(`/publications/${publicationSlug}/topics`, { method: "POST", body: data, token });
}

export function updateTopic(token, topicId, data) {
  return request(`/topics/${topicId}`, { method: "PUT", body: data, token });
}

export function deleteTopic(token, topicId) {
  return request(`/topics/${topicId}`, { method: "DELETE", token });
}

// orderedTopicIds is every topic in this category section, in its new
// display order (see PublicationTopicsPage.js's move up/down buttons).
export function reorderTopics(token, publicationSlug, category, orderedTopicIds) {
  return request(`/publications/${publicationSlug}/topics/reorder`, {
    method: "PUT",
    token,
    body: { category, topic_ids: orderedTopicIds },
  });
}
